import React from 'react'
import ErrorImage from '../../../../assets/img/no-image.png'
import { formatDateAndTime } from '../../../../components/commonClass/CommonValidation';
import { getAirlineLogo } from '../../../../components/commonClass/CommonFunctions';

const FlightReviewComponant = (props: any) => {
    function convertDurationToHM(duration: any, istotal: any) {
        if (istotal) {
            const layoverTimes = [];
            for (let i = 0; i < duration?.length - 1; i++) {
                const arrivalTime: any = new Date(duration[i].arrTime);
                const nextDepartureTime: any = new Date(duration[i + 1].depTime);
                const layoverDuration = nextDepartureTime - arrivalTime;
                if (layoverDuration > 0) {
                    const totalMinutes = Math.floor(layoverDuration / (1000 * 60));
                    layoverTimes?.push({
                        layover: totalMinutes,
                    });
                }
            }
            const totalDuration = duration?.reduce((sum: any, flight: any) => sum + flight?.duration, 0);
            const totallayover = layoverTimes?.reduce((sum, flight) => sum + flight?.layover, 0);
            const hours = Math?.floor((totalDuration + totallayover) / 60);
            const minutes = (totalDuration + totallayover) % 60;
            return `${hours}h ${minutes}m`;
        }
        else {
            const totalDuration = duration?.reduce((sum: any, flight: any) => sum + flight?.duration, 0);
            const hours = Math?.floor((totalDuration) / 60);
            const minutes = totalDuration % 60;
            return `${hours}h ${minutes}m`;
        }
    }
    const { flightData, isDomRtn, flightFareRuleData } = props;
    return (
        <div className="row flightdetail">
            <div className="title pr">
                <i className="fa-solid fa-plane-departure me-3"></i>
                <h5 className="mb-0">Flight Details</h5>
            </div>

            {flightData?.map((el: any, mainindex: any) =>
                el?.response?.results?.segments?.map((segment: any, index: any) => {
                    return (
                        <div key={`segment1${index + 1}`} className={`col-md-12 ${mainindex !== isDomRtn ? 'domrtn' : ''}`}>
                            <div className="duration">
                                <h4> {segment?.flightFromTo}</h4>
                                {(isDomRtn === 1 && mainindex === 0) && <div className='fw-bold text-end rounded-pill bg-success px-2 text-white'>Booked</div>}
                                <div className="text-end">
                                    <span>Duration</span>
                                    <p><i className="fa-regular fa-clock"></i> {convertDurationToHM(segment?.map((ele: any) => ({
                                        duration: ele?.duration,
                                        depTime: ele?.origin?.depTime,
                                        arrTime: ele?.destination?.arrTime
                                    })), true)}</p>
                                </div>
                            </div>

                            {segment?.length > 0 && segment.map((fly: any, index: any) => {
                                return (
                                    <React.Fragment key={`${fly?.segmentIndicator}${index + 1}`} >
                                        <div className={`flyDuration ${(index + 1) === segment?.length ? 'mb-3' : ''} `}>
                                            <div className="datePlace">
                                                <div className="date">
                                                    <h4>{formatDateAndTime(fly?.origin?.depTime)?.time}</h4>
                                                    <span>{formatDateAndTime(fly?.origin?.depTime)?.date}</span>
                                                </div>
                                                <div className="distance"><i className="fa-solid fa-circle-dot"></i></div>
                                                <div className="place">
                                                    <h4>{fly?.origin?.airport?.cityName}</h4>
                                                    <span>{fly?.origin?.airport?.airportName}</span>
                                                </div>
                                            </div>
                                            <div className="datePlace">
                                                <div className="date">
                                                    <h4>{convertDurationToHM([{
                                                        duration: fly?.duration,
                                                        depTime: fly?.origin?.depTime,
                                                        arrTime: fly?.destination?.arrTime
                                                    }], false)}</h4>
                                                </div>
                                                <div className="distance"><i className="fa-solid fa-plane-up"></i></div>
                                                <div className="place">
                                                    <span className="flightLogo"><img loading='lazy' src={getAirlineLogo(fly?.airline?.airlineCode)} onError={(e: any) => e.target.src = ErrorImage} height="24px" width="25px" alt="flights logo" /> {fly?.airline?.airlineName}&nbsp;|&nbsp;{fly?.airline?.airlineCode}-{fly?.airline?.flightNumber} </span>
                                                </div>
                                            </div>
                                            <div className="datePlace">
                                                <div className="date">
                                                    <h4>{formatDateAndTime(fly?.destination?.arrTime)?.time}</h4>
                                                    <span>{formatDateAndTime(fly?.destination?.arrTime)?.date}</span>
                                                </div>
                                                <div className="distance"><i className="fa-solid fa-circle-dot"></i></div>
                                                <div className="place">
                                                    <h4>{fly?.destination?.airport?.cityName}</h4>
                                                    <span>{fly?.destination?.airport?.airportName}</span>
                                                </div>
                                            </div>
                                        </div>
                                        {segment?.length !== (index + 1) && <div className="connectingTime">
                                            <span className="icon"><i className="fa-regular fa-clock"></i></span> <span> {fly?.layover} layover</span>
                                        </div>}
                                    </React.Fragment>
                                )
                            })}
                        </div>
                    )
                })
            )
            }

            <div className="col-md-12 mb-3">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="baggage-info-tab" data-bs-toggle="tab" data-bs-target="#baggageInfo" type="button" role="tab" aria-controls="baggageInfo" aria-selected="false">Baggage Information</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="cancel-change-rule-tab" data-bs-toggle="tab" data-bs-target="#cancelChangeRule" type="button" role="tab" aria-controls="cancelChangeRule" aria-selected="false">Cancellation &amp; Change Rule</button>
                    </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade" id="baggageInfo" role="tabpanel" aria-labelledby="baggage-info-tab">
                        <div className="hrScroll">
                            <div className="fare-details">
                                <div className="col-md-12">
                                    <div className="table-responsive baggage-info">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Airline</th>
                                                    <th>check in</th>
                                                    <th>cabin</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    flightData?.[isDomRtn]?.response?.results?.segments?.length > 0 && flightData?.[isDomRtn]?.response?.results?.segments?.map((baggageInfo: any, index: any) => {
                                                        return (
                                                            <React.Fragment key={`${index + 1}`} >
                                                                {
                                                                    baggageInfo?.map((bag: any, index: any) => {
                                                                        return (
                                                                            <tr key={`${bag?.segmentIndicator}${index + 1}`} >
                                                                                <td>
                                                                                    <div className="d-flex align-items-center">
                                                                                        <img
                                                                                            loading='lazy'
                                                                                            src={getAirlineLogo(bag?.airline?.airlineCode)}
                                                                                            onError={(e: any) => e.target.src = ErrorImage} height="24px" width="25px" alt="flights logo"
                                                                                        />
                                                                                        <div>
                                                                                            <p>{bag?.airline?.airlineName}</p>
                                                                                            <p>{bag?.airline?.airlineCode} - {bag?.airline?.flightNumber}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td>{bag?.baggage}	</td>
                                                                                <td>{bag?.cabinBaggage} </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }

                                                            </React.Fragment>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="terms">
                                        <ul>
                                            <li>Baggage information mentioned above is obtained from airline's reservation system, ETM does not guarantee the accuracy of this information. </li>
                                            <li>The baggage allowance may vary according to stop-overs, connecting flights. changes in airline rules. etc. </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="tab-pane fade" id="cancelChangeRule" role="tabpanel" aria-labelledby="cancel-change-rule-tab">
                        <div className="hrScroll">
                            <div className="fare-details">
                                <div className="col-md-12">
                                    {
                                        flightFareRuleData?.response?.fareRules?.length > 0 &&
                                        flightFareRuleData?.response.fareRules.map((rule: any, index: any) =>
                                        (
                                            rule?.fareRuleDetail ? (
                                                <div
                                                    className='fare_rules mb-3'
                                                    key={`fare-${index}`}
                                                    dangerouslySetInnerHTML={{ __html: rule?.fareRuleDetail }}
                                                />
                                            ) : null
                                        )
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FlightReviewComponant
